document.addEventListener("click", (e) => {
  const modal = document.querySelector("[data-size-guide]");
  if (!modal) return;

  if (e.target.matches(".size-guide-trigger")) {
    modal.classList.add("active");
    document.body.style.overflow = "hidden";
    return;
  }

  if (e.target.closest(".size-guide-close")) {
    modal.classList.remove("active");
    document.body.style.overflow = "";
    return;
  }

  if (!e.target.closest(".size-guide-content") && modal.classList.contains("active")) {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const detailsEl = document.querySelector(".product_variant_wrap");
  const selectedValueEl = detailsEl.querySelector(".selected_value");
  const optionItems = detailsEl.querySelectorAll(".option_value");

  // Fetch the option name from custom UI (example: size or shoe-size)
  const customOptionName = detailsEl.closest("[data-option]")?.getAttribute("data-option") || "size";

  optionItems.forEach(item => {
    item.addEventListener("click", () => {
      const selectedValue = item.getAttribute("value").trim();

      selectedValueEl.textContent = selectedValue;
      const variantWrap = document.querySelector(`[js-variant-wrap][data-option="${customOptionName}"]`);

      if (variantWrap) {
        const selectEl = variantWrap.querySelector("select");
        const inputEls = variantWrap.querySelectorAll('input[type="radio"]');
        if (selectEl) {
          selectEl.value = selectedValue;
          selectEl.dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (inputEls.length > 0) {
          inputEls.forEach(input => {
            if (input.value.trim() === selectedValue) {
              input.checked = true;
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        }
      }

      detailsEl.removeAttribute("open");
    });
  });
  document.addEventListener("click", function (e) {
    if (!detailsEl.contains(e.target)) {
      detailsEl.removeAttribute("open");
    }
  });
});

if(document.querySelector("[js-index-page]")) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      document.querySelector('[js-hero-banner]').classList.add('fade-out');
    }, 350);
    setTimeout(() => {
      window.location.href = "/collections/all"
    }, 600);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const sidebarDetails = document.querySelectorAll("[js-sidebar-details]");
  
  if (window.innerWidth < 990) {
    sidebarDetails.forEach(el => {
      if (el.hasAttribute("open")) el.removeAttribute("open");
    });
  }
});